import React, { useState, useEffect } from 'react';
import {
  ArrowRight, PlusCircle, MinusCircle, Download,
  Landmark, Wallet, Percent, FileText, ChevronRight,
  PiggyBank, BriefcaseBusiness,
  BadgeDollarSign, Upload, DownloadCloud,
  HandCoins, Filter, ChevronLeft,
  Database,
  PieChart,
  Calendar,
  CirclePercent, X
} from 'lucide-react';

import styles from './SavingsApplications.module.css';
import Sidebar2 from '../../Components/SideBar2/SideBar2';
import Header2 from '../../Components/Header2/Header2';
import axios from 'axios';
import { BASE_URL } from '../../Components/Api/Api';
import { Form, Placeholder } from "react-bootstrap";
import Select from "react-select";

const tableColumnCount = 8; // S/N, Reference No, Description, Transaction Date, Type, Debit, Credit, Balance

export default function SavingsApplications() {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [loading, setLoading] = useState(true);       // table loading
  const [statsLoading, setStatsLoading] = useState(true); // cards loading

  const [ledgers, setLedgers] = useState([]);          // full dataset for the currently selected loan
  const [displayedLedgers, setDisplayedLedgers] = useState([]); // dataset after the date filter is applied
  const [stats, setStats] = useState({});

  const [savings, setSavings] = useState([]);
  const [savingsType, setSavingsType] = useState(null);
  const [selectedDate, setSelectedDate] = useState("");

const CardSkeleton = () => (
  <div className={styles.statCard}>
    {/* Icon */}
    <Placeholder
      as="div"
      animation="glow"
      style={{
        width: 36,
        height: 36,
        borderRadius: 8,
        display: "flex",
      }}
    >
      <Placeholder
        xs={12}
        style={{
          width: "100%",
          height: "100%",
          borderRadius: 8,
        }}
      />
    </Placeholder>

    <div className={styles.statContent} style={{ width: "100%" }}>
      <Placeholder animation="glow">
        <Placeholder
          xs={5}
          style={{
            display: "block",
            height: 12,
            marginBottom: 8,
            borderRadius: 4,
          }}
        />

        <Placeholder
          xs={7}
          style={{
            display: "block",
            height: 22,
            marginBottom: 18,
            borderRadius: 4,
          }}
        />

        <Placeholder
          xs={4}
          style={{
            display: "block",
            height: 10,
            marginTop: 10,
            borderRadius: 4,
          }}
        />
      </Placeholder>
    </div>
  </div>
);

const formatCurrency = (value) => `₦${Number(value || 0).toLocaleString('en-NG')}`;
  const formatCurrencys = (value) =>
    Number(value ?? 0).toLocaleString("en-NG", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    
const formatMetricValue = (value, type = "number") => {
  const numericValue = Number(value);

  // Handle invalid values
  if (
    value === null ||
    value === undefined ||
    value === "" ||
    Number.isNaN(numericValue)
  ) {
    return type === "currency" ? "₦0.00" : "0";
  }

  // Percent
  if (type === "percent") {
    return `${numericValue.toFixed(0)}%`;
  }

  // Currency
  if (type === "currency") {
    const absValue = Math.abs(numericValue);
    const sign = numericValue < 0 ? "-" : "";

    let formatted;

    if (absValue >= 1_000_000_000_000) {
      formatted = `${(absValue / 1_000_000_000_000)
        .toFixed(1)
        .replace(/\.0$/, "")}T`;
    } else if (absValue >= 1_000_000_000) {
      formatted = `${(absValue / 1_000_000_000)
        .toFixed(1)
        .replace(/\.0$/, "")}B`;
    } else if (absValue >= 1_000_000) {
      formatted = `${(absValue / 1_000_000)
        .toFixed(1)
        .replace(/\.0$/, "")}M`;
    } else if (absValue >= 1_000) {
      formatted = `${(absValue / 1_000)
        .toFixed(1)
        .replace(/\.0$/, "")}K`;
    } else {
      formatted = absValue.toLocaleString("en-NG", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }

    return `${sign}₦${formatted}`;
  }

  // Normal numbers
  if (Number.isInteger(numericValue)) {
    return numericValue.toLocaleString("en-NG");
  }

  return numericValue.toLocaleString("en-NG", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

  // ---- data fetching ----
  const fetchLedger = async (savingsId = null, date = null) => {
    setLoading(true);

    try {
      const token = localStorage.getItem("token");
      const companyid = localStorage.getItem("companyId");
      // const compid = localStorage.getItem("companyId");
     const memberid = localStorage.getItem("memberId");

      let url = `${BASE_URL}/my_savings_ledger?company_id=${companyid}&member_id=${memberid}`;

      if (savingsId) {
        url += `&savings_id=${savingsId}`;
      }
      // if (date) {
      //   url += `&date=${date}`;
      // }

      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      const data = res.data?.data || {};
      const ledgerData = data.table_data || [];

      setLedgers(data.table_data || []);
      setStats(data.summary || {});
      setCurrentPage(1); // reset to page 1 whenever the underlying dataset changes
      // Keep whatever date filter is currently active applied to the freshly fetched data
      if (selectedDate) {
        setDisplayedLedgers(
          ledgerData.filter((item) => item.transaction_date === selectedDate)
        );
      } else {
        setDisplayedLedgers(ledgerData);
      }
    } catch (error) {
      console.error(error);
      setLedgers([]);
       setDisplayedLedgers([]);
      setStats({});
    } finally {
      setLoading(false);
    }
  };

  const fetchInvoices = async () => {
    try {
      const token = localStorage.getItem("token");
      const companyid = localStorage.getItem("companyId");
      // const compid = localStorage.getItem("companyId");
    const memberid = localStorage.getItem("memberId");

      const res = await axios.get(
        `${BASE_URL}/member-auth/member_loan_plans?company_id=${companyid}&member_id=${memberid}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      const savingsData = res.data?.data || [];
      setSavings(savingsData);
    } catch (error) {
      console.error(error);
      setSavings([]);
    }
  };

  useEffect(() => {
    fetchLedger();      // default load — no loan_id
    fetchInvoices();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const savingsOptions = savings.map((item) => ({
  //   value: item.loan?.id,
  //   label: item.loan?.loan_name || item.type?.product_name,
  //   ...item.type,
  // }));

  const selectStyles = {
    control: (base) => ({
      ...base,
      borderRadius: "10px",
      fontSize: "12px",
      minHeight: 40,
      height: "auto",
    }),
    valueContainer: (base) => ({
      ...base,
      height: 40,
      padding: "0 8px",
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: 40,
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#15803d"
        : state.isFocused
        ? "#EBFFF3"
        : "transparent",
      color: state.isSelected ? "#fff" : "inherit",
      fontSize: "12px",
      cursor: "pointer",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#6c757d",
      fontSize: "12px",
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: "12px",
      color: "#212529",
    }),
    menu: (base) => ({
      ...base,
      borderRadius: "0.375rem",
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      zIndex: 9999,
    }),
  };

  // ---- filter handlers ----
  const handleSavingsTypeChange = (selected) => {
    setSavingsType(selected);
    fetchLedger(selected?.value || null); // now sent as loan_id
  };

  const handleRemoveFilter = () => {
    setSavingsType(null);
    fetchLedger(null);
  };

  const handleDateChange = (e) => {
    const date = e.target.value;
    setSelectedDate(date);
    setCurrentPage(1);

    if (date) {
      setDisplayedLedgers(
        ledgers.filter((item) => item.transaction_date === date)
      );
    } else {
      setDisplayedLedgers(ledgers);
    }
  };

  // ---- pagination (driven by the actual API data) ----
  const totalItems = displayedLedgers.length;
  const totalPages = Math.max(1, Math.ceil(totalItems / itemsPerPage));
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentTransactions = displayedLedgers.slice(startIndex, endIndex);

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const goToPage = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  // ---- stat cards, built from live `stats` state ----
  const loanStats = [
    {
      id: 'owed',
      label: 'Total Loan Owed',
      // value: `₦${formatCurrencys(stats.total_loan_owe)}`,
      value: formatMetricValue(stats.total_loan_owe, "currency"),
      detail: 'Principal amount owed',
      bgColor: '#eaf8ef',
      textColor: '#059447',
      icon: <Wallet size={22} color="#059447" />,
    },
    {
      id: 'repayment',
      label: 'Total Loan Repayment',
      // value: `₦${formatCurrencys(stats.total_loan_repayment)}`,
      value: formatMetricValue(stats.total_loan_repayment, "currency"),
      detail: 'All time repayment',
      bgColor: '#dbeafe',
      textColor: '#0284c7',
      icon: <Database size={22} color="#0284c7" />,
    },
    {
      id: 'balance',
      label: 'Loan Balance',
      value: formatMetricValue(stats.loan_balance, "currency"),
      detail: 'Current outstanding balance',
      bgColor: '#fee2e2',
      textColor: '#dc2626',
      icon: <PieChart size={22} color="#f59e0b" />,
    },
    {
      id: 'currentMonth',
      label: 'Current Month Repayment',
      value: formatMetricValue(stats.current_month_repayment, "currency"),
      detail: 'Repayment made this month',
      bgColor: '#f3e8ff',
      textColor: '#a855f7',
      icon: <Calendar size={22} color="#9333ea" />,
    },
  ];

  return (
    <div className={styles.container}>
      <Sidebar2 active="savings" />

      <main className={styles.mainContent}>
        <Header2 title="My Savings" />

        <div className={styles.workspace}>
          {/* Stats Cards */}
         

          {/* Transaction Ledger Section */}
          <div className={styles.ledgerSection}>
            <div className={styles.ledgerHeader}>
              <div>
                <h2>My Savings</h2>
                <p>Detailed view of all your savings.</p>
              </div>

              <div className={styles.ledgerControls}>
                {/* <Select
                  options={savingsOptions}
                  value={savingsType}
                  onChange={handleSavingsTypeChange}
                  placeholder="Select Loan Type"
                  isLoading={loading}
                  styles={selectStyles}
                /> */}

                {/* {savingsType && (
                  <button
                    type="button"
                    className={styles.exportBtn}
                    onClick={handleRemoveFilter}
                    title="Clear filter"
                  >
                    <X size={16} />
                    Clear
                  </button>
                )} */}

                {/* <div className={styles.dateRange}>
                  <Form.Control
                    type="date"
                    value={selectedDate}
                    onChange={handleDateChange}
                  />
                </div> */}

                {/* <button className={styles.exportBtn} type="button">
                  <Download size={16} />
                  Print
                </button> */}
              </div>
            </div>

            {/* Table */}
            <div className={styles.tableWrapper}>
              <table className={styles.transactionTable}>
                <thead>
                  <tr>
                    <th>S/N</th>
                    <th>Reference No.</th>
                    <th>Savings Product</th>
                    <th>Description</th>
                    <th>Transaction Date</th>
                    {/* <th>Approval Status</th> */}
                    <th style={{ textAlign: 'right' }}>Amount</th>
                    {/* <th style={{ textAlign: 'right' }}>Credit</th>
                    <th style={{ textAlign: 'right' }}>Balance</th> */}
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    Array.from({ length: 6 }).map((_, rowIdx) => (
                      <tr key={`skeleton-${rowIdx}`}>
                        {Array.from({ length: tableColumnCount }).map((__, colIdx) => (
                          <td key={colIdx}>
                            <Placeholder as="span" animation="glow">
                              <Placeholder xs={colIdx === 0 ? 4 : 8} />
                            </Placeholder>
                          </td>
                        ))}
                      </tr>
                    ))
                  ) : currentTransactions.length === 0 ? (
                    <tr>
                      <td colSpan={tableColumnCount} style={{ textAlign: 'center', padding: '24px' }}>
                        No transactions found.
                      </td>
                    </tr>
                  ) : (
                    currentTransactions.map((item, index) => {
                      const statusNum = Number(item.status);
                      const isDisbursement = statusNum === 1;
                      const typeLabel = isDisbursement ? 'Approved' : statusNum === 2 ? 'Rejected' : '—';
                      const typeColor = isDisbursement ? '#16a34a' : '#dc2626';

                      return (
                        <tr key={item.id}>
                          <td>{startIndex + index + 1}</td>
                          <td>{item.uuid}</td>
                          <td style={{  }}>{item.type?.product_name}</td>
                          <td style={{ width: "25%", maxWidth: "25%" }}>{item.description}</td>
                          <td className={styles.dateCell}>{item.transaction_date}</td>
                          {/* <td>
                            <span
                              className={styles.typeTag}
                              style={{
                                color: typeColor,
                                backgroundColor: `${typeColor}15`,
                              }}
                            >
                              {typeLabel}
                            </span>
                          </td> */}
                          <td style={{ textAlign: 'right' }}>{formatCurrencys(item.credit)}</td>
                          {/* <td style={{ textAlign: 'right' }}>{formatCurrencys(item.balance)}</td> */}
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <div className={styles.paginationContainer}>
              <p className={styles.paginationInfo}>
                {totalItems === 0
                  ? 'Showing 0 of 0 transactions'
                  : `Showing ${startIndex + 1} to ${Math.min(endIndex, totalItems)} of ${totalItems} transactions`}
              </p>

              <div className={styles.paginationControls}>
                <button
                  type="button"
                  className={styles.paginationBtn}
                  onClick={() => goToPage(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  <ChevronLeft size={16} />
                </button>

                {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                  <button
                    key={page}
                    type="button"
                    className={`${styles.paginationBtn} ${
                      page === currentPage ? styles.activePage : ''
                    }`}
                    onClick={() => goToPage(page)}
                  >
                    {page}
                  </button>
                ))}

                <button
                  type="button"
                  className={styles.paginationBtn}
                  onClick={() => goToPage(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  <ChevronRight size={16} />
                </button>
              </div>

              <div className={styles.itemsPerPage}>
                <select value={itemsPerPage} onChange={handleItemsPerPageChange}>
                  <option value={10}>10 / page</option>
                  <option value={20}>20 / page</option>
                  <option value={50}>50 / page</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
